





















import { Component, Prop, Vue } from 'vue-property-decorator'

export const isExternalLink = function (url: string): boolean {
  const reDoc = /^https?/
  return reDoc.test(url)
}

@Component({
  components: {}
})
export default class LinkEx extends Vue {
  @Prop({ required: true }) private href!: string
  @Prop({ default: () => [] }) private addClass!: string[]
  @Prop({ default: '_blank' }) private target!: string
  @Prop({ default: false }) private showExternalIcon!: boolean

  // ------------------------------------------------------------------------------------------------
  // methods
  /**
   * 外部リンクか判定する
   */
  get isExternalLink(): boolean {
    return isExternalLink(this.href)
  }

  /**
   * リンクのクラスを取得する
   */
  get linkClass(): string[] {
    const addClass: string[] = this.addClass
    if (this.isExternalLink) {
      // 外部リンクのなら、計測用クラスを追加
      addClass.push('log-externallink')
    }
    return addClass
  }
}
